// extracted by mini-css-extract-plugin
module.exports = {"className":"textHeadingM_className__ztLdG"};